// Types
type IconProps = {
  size?: number;
  className?: string;
};

/**
 * Microsoft Excel icon
 */
export const ExcelIcon = ({ size = 26, className }: IconProps) => (
  <svg
    width={size}
    height={(size * 24) / 26}
    viewBox="0 0 26 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden="true"
  >
    <g clipPath="url(#excel_clip0)">
      <path
        d="M15.8205 11.1328L5.85938 9.375V22.3637C5.85938 22.9568 6.34024 23.4377 6.93341 23.4377H24.1216C24.7147 23.4377 25.1956 22.9568 25.1956 22.3637V17.5782L15.8205 11.1328Z"
        fill="#185C37"
      />
      <path
        d="M15.8205 0H6.93341C6.34024 0 5.85938 0.480861 5.85938 1.07404V5.85946L15.8205 11.7189L21.094 13.4768L25.1956 11.7189V5.85946L15.8205 0Z"
        fill="#21A366"
      />
      <path d="M5.85938 5.85938H15.8205V11.7188H5.85938V5.85938Z" fill="#107C41" />
      <path
        opacity="0.1"
        d="M12.9886 4.6875H5.85938V19.3361H12.9886C13.581 19.3342 14.0607 18.8545 14.0626 18.2621V5.76154C14.0607 5.16916 13.581 4.68943 12.9886 4.6875Z"
        fill="black"
      />
      <path
        opacity="0.2"
        d="M12.4026 5.27344H5.85938V19.9221H12.4026C12.995 19.9202 13.4747 19.4404 13.4767 18.848V6.34747C13.4747 5.7551 12.995 5.27536 12.4026 5.27344Z"
        fill="black"
      />
      <path
        opacity="0.2"
        d="M12.4026 5.27344H5.85938V18.7502H12.4026C12.995 18.7483 13.4747 18.2685 13.4767 17.6762V6.34747C13.4747 5.7551 12.995 5.27536 12.4026 5.27344Z"
        fill="black"
      />
      <path
        opacity="0.2"
        d="M11.8167 5.27344H5.85938V18.7502H11.8167C12.4091 18.7483 12.8888 18.2685 12.8907 17.6762V6.34747C12.8888 5.7551 12.4091 5.27536 11.8167 5.27344Z"
        fill="black"
      />
      <path
        d="M1.07404 5.27344H11.8168C12.4099 5.27344 12.8908 5.7543 12.8908 6.34747V17.0902C12.8908 17.6834 12.4099 18.1642 11.8168 18.1642H1.07404C0.480861 18.1642 0 17.6834 0 17.0902V6.34747C0 5.7543 0.480861 5.27344 1.07404 5.27344Z"
        fill="url(#excel_paint0)"
      />
      <path
        d="M3.32617 15.2098L5.58558 11.7087L3.51544 8.22705H5.18069L6.31039 10.4536C6.4147 10.6652 6.48618 10.8222 6.52485 10.9259H6.5395C6.61372 10.7572 6.69185 10.5933 6.77388 10.4343L7.98151 8.22823H9.51024L7.38735 11.6894L9.56416 15.2098H7.93757L6.63267 12.7658C6.5712 12.6618 6.51904 12.5526 6.47681 12.4394H6.45748C6.41925 12.5503 6.36854 12.6564 6.3063 12.7558L4.96273 15.2098H3.32617Z"
        fill="white"
      />
      <path
        d="M24.1224 0H15.8213V5.85946H25.1964V1.07404C25.1964 0.480861 24.7156 0 24.1224 0Z"
        fill="#33C481"
      />
      <path d="M15.8213 11.7188H25.1964V17.5782H15.8213V11.7188Z" fill="#107C41" />
    </g>
    <defs>
      <linearGradient
        id="excel_paint0"
        x1="2.23939"
        y1="4.43421"
        x2="10.6514"
        y2="19.0035"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#18884F" />
        <stop offset="0.5" stopColor="#117E43" />
        <stop offset="1" stopColor="#0B6631" />
      </linearGradient>
      <clipPath id="excel_clip0">
        <rect width="25.1957" height="23.4378" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
